
(function($) {



$(function($){


    let $wiz = $('#smartwizard');

    // Toolbar extra buttons
    var btnFinish = $('<button></button>').text(localize.translations.koncaj)
                                     .addClass('btn btn-primary sw-btn-finish d-none')
                                     .on('click', function(){
                                        $wiz.smartWizard("reset");
                                        document.getElementById('smartwizard').scrollIntoView({
                                            behavior: 'smooth'
                                        });
                                    });
    var btnCancel = $('<button></button>').text('Cancel')
                                     .addClass('btn btn-danger')
                                     .on('click', function(){ $wiz.smartWizard("reset"); });

     
    // SmartWizard initialize
    $wiz.smartWizard({
        selected: 0, // Initial selected step, 0 = first step
        //justified: true, // Nav menu justification. true/false
        //darkMode:false, // Enable/disable Dark Mode if the theme supports. true/false
        //autoAdjustHeight: true, // Automatically adjust content height
        cycleSteps: false, // Allows to cycle the navigation of steps
        backButtonSupport: false, // Enable the back button support
        enableURLhash: false, // Enable selection of the step based on url hash
        transition: {
            animation: 'none', // Effect on navigation, none/fade/slide-horizontal/slide-vertical/slide-swing
            speed: '400', // Transion animation speed
            easing:'' // Transition animation easing. Not supported without a jQuery easing plugin
        },
        toolbarSettings: {
            toolbarPosition: 'bottom', // none, top, bottom, both
            //toolbarButtonPosition: 'center', // left, right, center
            showNextButton: true,  // show/hide a Next button
            showPreviousButton: true, // show/hide a Previous button
            toolbarExtraButtons: [btnFinish] // Extra buttons to show on toolbar, array of jQuery input/buttons elements
        },
        anchorSettings: {
            anchorClickable: true, // Enable/Disable anchor navigation
            enableAllAnchors: false, // Activates all anchors clickable all times
            markDoneStep: true, // Add done state on navigation
            markAllPreviousStepsAsDone: false, // When a step selected by url hash, all previous steps are marked done
            removeDoneStepOnNavigateBack: true, // While navigate back done step after active step will be cleared
            enableAnchorOnDoneStep: true // Enable/Disable the done steps navigation
        },
        /*keyboardSettings: {
            keyNavigation: true, // Enable/Disable keyboard navigation(left and right keys are used if enabled)
            keyLeft: [37], // Left key code
            keyRight: [39] // Right key code
        },*/
        lang: { // Language variables for button
            next: localize.translations.naprej,
            previous: localize.translations.nazaj
        },
        disabledSteps: [], // Array Steps disabled 1,2,3
        errorSteps: [], // Highlight step with errors
        hiddenSteps: [] // Hidden steps
      });

      $wiz.find(".sw-btn-prev").addClass('d-none');

      // Step show event
      
      $wiz.on("showStep", function(e, anchorObject, stepNumber, stepDirection, stepPosition) {

        console.log('showStep', e);
        console.log('showStep', anchorObject.data());

        

        //$(this).find('.tab-content').removeAttr('style');

        //$panel.parent('.tab-content').removeAttr('style');
        //$(".sw-btn-prev").removeClass('disabled');
        //$(".sw-btn-next").removeClass('disabled');

       // $(this).find(".sw-btn-next").text('Naprej');
       
        $(this).find(".sw-btn-next").removeClass('d-none');
        $(this).find(".sw-btn-finish").addClass('d-none');
        $(this).find(".sw-btn-prev").removeClass('d-none');

        if(stepPosition === 'first') {
            $(this).find(".sw-btn-prev").addClass('d-none');
            console.log('first-step');

        } else if(stepPosition === 'last') {
            $(this).find(".sw-btn-next").addClass('d-none');
            $(this).find(".sw-btn-finish").removeClass('d-none');
        } else {  
            //$(this).find(".sw-btn-prev").removeClass('disabled');
           // $(this).find(".sw-btn-next").removeClass('disabled');
        }
    });

      var $pitem = '';
      var activeSelector = 'active shadow';
      let $pagewrapper = $('#page-wrapper');


      $wiz.find('.tab-content > .tab-pane').each(function(i, el){

        $(el).find('.post-item').on('click', '.details-trigger', function(e){
            //console.log(e);
                e.stopPropagation();
                var $smallbtn = $(e.currentTarget);
                var $mainTarget = $(e.delegateTarget);
                $mainTarget.siblings().find('.details').removeClass('show');
                $mainTarget.find('.details').toggleClass('show');
                return false;

        });
        //console.log(i);
        $(el).on('click', '.post-item', function(e){

                $pitem = $(e.currentTarget);
                $pitem
                .addClass(activeSelector)
                .siblings().removeClass(activeSelector);

                let postid = $pitem.data('postid');
                let $panel = $(e.delegateTarget);
                let $next = $panel.next();
                let $next_step = $next.index();

                if($panel.next()) {
                    $wiz.find(".sw-btn-next").addClass('disabled');
                }

               

            
                return new Promise((resolve, reject) => {
     
                    // Ajax call to fetch your content
                    $.ajax({
                        method  : "GET",
                        url     : localize.ajaxurl,
                        data    : { 'action' : 'guide_selection_callback', 'step' : $next_step, 'post_id' : postid  },
                        beforeSend: function( xhr ) {
                            // Show the loader
                            $wiz.smartWizard("loader", "show");
                        }
                    }).done(function( res ) {
                        $next.html(res);
                        if(res) {
                            $wiz.smartWizard("stepState", [$next_step], "enable");
                            $wiz.find(".sw-btn-next").removeClass('disabled');
                            $panel.data('isDone', true);
                            if($pitem.is(':checkbox')) {

                                if($pitem.is(':checked')){

                                    $('#consent-warning').hide();
                                } else {
                                    $panel.data('isDone', false);
                                    $('#consent-warning').show();
                                }
                                //console.log('is checkbox');
                                
                            }
                            
                            
                            //$panel.parent('.tab-content').removeAttr('style');
                        }
    
                        // Resolve the Promise with the content
                        resolve(res);
               
                        // Hide the loader
                        $wiz.smartWizard("loader", "hide");
                    }).fail(function(err) {
               
                        // Reject the Promise with error message to show as content
                        reject( "An error loading the resource" );
               
                        // Hide the loader
                        $wiz.smartWizard("loader", "hide");
                    });
               
                  });
                
                //console.log($(e.delegateTarget).next());
                    
        });


      });


      // Initialize the leaveStep event
       $wiz.on("leaveStep", function(e, anchorObject, currentStepIndex, nextStepIndex, stepDirection) {

        
        let test = $('#step-' + currentStepIndex).data('isDone');
        var $consent = $('#step-' + currentStepIndex).find('#consent');
        //let nextstep = $('#step-' + nextStepIndex).data('isDone');
        //console.log(test);

        if($consent.length > 0) {

            if($consent.is(':checked')) {
                document.getElementById('smartwizard').scrollIntoView({
                    behavior: 'smooth'
                });
            }


        } else {
            document.getElementById('smartwizard').scrollIntoView({
                behavior: 'smooth'
            });
        }

        
       
       

        if(stepDirection === 'forward') {


            //console.log('currentStepIndex', currentStepIndex);

            if(test === true) {
                return true;

           } else {

             

             if($consent.length > 0) {
                if(!$consent.is(':checked')) {
                    var $warning = $('#consent-warning').text(anchorObject.data('warning'))
                }
             } else {
                alert(anchorObject.data('warning'));
             }
              return false;
           }

        } else {

            if(currentStepIndex === 0) {

                //$wiz.find(".sw-btn-next").removeClass('d-none');

            }


        }

            
            //console.log(anchorObject.data());
            //  

        });
        // Initialize the stepContent event
        $wiz.on("stepContent", function(e, anchorObject, stepIndex, stepDirection) {
            //console.log(stepIndex);
            // display content
            let outside_cont = $pagewrapper.find('.dynamic-wrapper');
            outside_cont.find('.dynamic-title').empty().text(anchorObject.data('title'));
            outside_cont.find('.dynamic-content').empty().text(anchorObject.data('content'));
  
        });

   /* $("#smartwizard").on("stepContent", function(e, anchorObject, stepIndex, stepDirection) {

        // Read data value from the anchor element
        var repo    = anchorObject.data('repo');
        var ajaxURL = "https://api.npms.io/v2/package/" + repo;

    
     
        // Return a promise object
        return new Promise((resolve, reject) => {
     
          // Ajax call to fetch your content
          $.ajax({
              method  : "GET",
              url     : ajaxURL,
              beforeSend: function( xhr ) {
                  // Show the loader
                  $('#smartwizard').smartWizard("loader", "show");
              }
          }).done(function( res ) {
              var html = 'Ajax data about ' + repo + ' loaded from GitHub';
              html += 'URL:' + ajaxURL;
              html += 'Name:' + res.collected.metadata.name;
     
              // Resolve the Promise with the content
              resolve(html);
     
              // Hide the loader
              $('#smartwizard').smartWizard("loader", "hide");
          }).fail(function(err) {
     
              // Reject the Promise with error message to show as content
              reject( "An error loading the resource" );
     
              // Hide the loader
              $('#smartwizard').smartWizard("loader", "hide");
          });
     
        });
    });*/


    });
   
})( jQuery );
